exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".made-in-us{\n    width: 50%;\n    margin: 0 auto;\n}\n\n.home-hero{\n    margin-top: -7px;\n}\n\n.review-margin{\n    margin-top: -10px;\n}\n\n.product-main-page-image {\n    padding: 4%;\n}\n\n.fade-in {\n\t-webkit-animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n\t        animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\n/* ----------------------------------------------\n * Generated by Animista on 2018-5-4 14:15:29\n * w: http://animista.net, t: @cssanimista\n * ---------------------------------------------- */\n\n/**\n * ----------------------------------------\n * animation fade-in\n * ----------------------------------------\n */\n\n@-webkit-keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n@keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n.has-bg-img { background: url('/assets/bike_hero.jpg')center center; background-size:cover; }\n\n.per-set {\n    font-size: 12px;\n    color: grey;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/samirjha/Project/nushing/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main